/* Svensk katalog for locale-bank-misc-no.js (del 2 av 3).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'km.privateDrivingHelp': 'Privat användning är dokumenterad i körjournalen, men ger inget avdrag.',
  'km.filterType': 'Typ',
  'km.tryOtherSearch': 'Prova en annan sökning eller återställ filtret.',
  'km.distance': 'Sträcka',
  'km.stops': 'Stopp',
  'km.returnYes': 'Ja ({km} km varje väg)',
  'km.returnNo': 'Nej',
  'km.status': 'Status',
  'km.statusLogged': 'Loggad',
  'km.statusPosted': 'Bokförd',
  'km.route': 'Rutt',
  'km.amount': 'Belopp',
  'km.deleteTripBody': 'Är du säker på att du vill ta bort den här resan{route}? Åtgärden kan inte ångras.',
  'km.speedUnit': 'km/h',
  'km.gps.unavailable': 'GPS är inte tillgänglig i den här webbläsaren.',
  'km.gps.denied': 'GPS-åtkomst nekades eller kunde inte startas.',
  'km.gps.active': 'GPS aktiv',
  'km.gps.inactive': 'GPS är inte aktiv',
  'km.gps.stop': 'Stoppa resa',
  'km.gps.start': 'Starta resa',
  'km.gps.done': 'Resan slutförd',
  'km.gps.tracking': 'Spårar din position.',
  'km.gps.doneHint': '{km} km registrerade. Använd sträckan i formuläret nedan.',
  'km.gps.startHint': 'Starta resan för att aktivera GPS-spårning.',
  'km.toast.editTrip': 'Redigera resa - ändra och spara på nytt',
  'km.toast.openedNotFound': 'Öppnade körjournalen. Hittade inte exakt den resa som skulle redigeras automatiskt.',
  'km.toast.fillFromTo': 'Fyll i minst från- och till-adress först.',
  'km.toast.calcUnavailable': 'Automatisk km-beräkning är inte tillgänglig ännu.',
  'km.toast.distanceFailed': 'Kunde inte beräkna avstånd.',
  'km.toast.kmCalculated': 'Kilometer beräknade automatiskt',
  'km.toast.calcFailed': 'Kunde inte beräkna kilometer automatiskt.',
  'km.toast.fillPrivate': 'Fyll i datum, från, till och kilometer innan du sparar privat körning.',
  'km.toast.fillBusiness': 'Fyll i datum, från, till, syfte och kilometer innan du sparar.',
  'km.toast.updated': 'Resan har uppdaterats',
  'km.toast.saved': 'Resan har sparats',
  'km.toast.deleted': 'Resan har tagits bort',
  'bank.filter.all': 'Alla',
  'bank.filter.processing': 'Att hantera',
  'bank.filter.suggestion': 'Förslag klart',
  'bank.filter.control': 'Behöver kontrolleras',
  'bank.filter.missing': 'Saknar verifikation',
  'bank.filter.deviation': 'Möjlig avvikelse',
  'bank.filter.done': 'Klar',
  'bank.typeGroup.sales': 'Försäljning',
  'bank.typeGroup.purchase': 'Inköp',
  'bank.typeGroup.other': 'Övrigt',
  'bank.typeGroup.tax': 'Skatter och avgifter',
  'bank.typeGroup.loan': 'Lån och skulder',
  'bank.type.invoicePayment': 'Fakturabetalning',
  'bank.type.otherSales': 'Övrig försäljning',
  'bank.type.payOpenSupplier': 'Leverantörsfaktura: betala öppen',
  'bank.type.newSupplier': 'Leverantörsfaktura: registrera ny',
  'bank.type.purchase': 'Vanligt inköp',
  'bank.type.free': 'Fri kontering',
  'bank.type.fee': 'Avgift',
  'bank.type.rounding': 'Öresdifferens / öresavrundning',
  'bank.type.owner': 'Privat uttag / insättning',
  'bank.type.vat': 'Momsbetalning',
  'bank.type.payroll': 'Skatteavdrag / AGA',
  'bank.type.tax': 'Skattebetalning',
  'bank.type.loan': 'Lån / skulder',
  'bank.agaPart.withholding': 'Skatteavdrag mot 2600',
  'bank.agaPart.employer': 'Arbetsgivaravgift mot 2770',
  'bank.agaPart.both': 'Båda samlat, fördelat på 2600 och 2770',
  'bank.vat.none': 'Ingen moms',
  'bank.vat.input': '{{code}} - Ingående moms {{rate}} %',
  'bank.accountFallback': 'Konto {{code}}',
  'bank.countsAsZero': '{{note}} · räknas som 0,00 kr i avstämningen',
  'bank.csv.date': 'Datum',
  'bank.csv.description': 'Beskrivning',
  'bank.csv.note': 'Anteckning',
  'bank.csv.amount': 'Belopp',
  'bank.csv.balance': 'Saldo',
  'bank.posted.amount': 'Bokfört {{amount}}',
  'bank.posted': 'Bokförd',
  'bank.posted.vatAmount': 'Moms {{amount}} ({{rate}} %)',
  'bank.posted.vatRate': 'Moms {{rate}} %',
  'bank.err.pickSupplierInvoice': 'Välj den leverantörsfaktura som betalningen avser.',
  'bank.err.supplierPaymentMustBeOutgoing': 'Betalning av leverantörsfaktura måste vara en utbetalning från banken.',
  'bank.err.supplierPaymentUnavailable': 'Betalning av leverantörsfaktura från bank är inte tillgänglig ännu.',
  'bank.deviation.intro': 'Dessa poster är bokförda mot bankkontot, men Plumme hittar ingen säker bankrad som förklarar dem.',
  'bank.deviation.none': 'Inga möjliga avvikelser under den här perioden.',
  'bank.detail.date': 'Datum',
  'bank.detail.amount': 'Belopp',
  'bank.detail.status': 'Status',
  'bank.detail.postId': 'Post-ID',
  'bank.detail.type': 'Typ',
  'bank.detail.period': 'Period',
  'bank.detail.noReceipt': 'Ingen verifikation är kopplad till konteringen',
  'bank.detail.receiptPreviewable': 'Verifikationen kan förhandsgranskas direkt här.',
  'bank.detail.noPreview': 'Det finns ingen verifikation att förhandsgranska.',
  'bank.toast.postingCorrected': 'Den bokförda konteringen har korrigerats',
  'bank.toast.postingVoided': 'Konteringen har makulerats. Eventuell verifikation ligger kvar i inkorgen.',
  'bank.transition.review': 'Kontrollera övergången från importerad bokföring innan det här kontoutdraget bokförs.',
  'bank.transition.fixOpening': '{{message}} Rätta ingående saldo innan du bokför.',
  'bank.toast.voucherLinkedName': 'Verifikation kopplad: {{name}}',
  'bank.toast.noVoucherSuggestions': 'SuperPlumma har inga verifikationsförslag att koppla.',
  'bank.toast.oneVoucherLinked': 'En verifikation har kopplats',
  'bank.toast.nVouchersLinked': '{{count}} verifikationer har kopplats',
  'bank.toast.linkSuggestedFailed': 'Kunde inte koppla de föreslagna verifikationerna.',
  'bank.toast.linkedToPosted': 'Bankraden är kopplad till den redan bokförda posten',
  'bank.toast.linkToPostedFailed': 'Kunde inte koppla bankraden till den bokförda posten.',
  'bank.toast.saveCustomerFirst': 'Spara kunden innan raden godkänns.',
  'bank.toast.saveSupplierFirst': 'Spara eller välj leverantören innan raden godkänns.',
  'bank.toast.reviewSuggestionFirst': 'Kontrollera förslaget i bankraden innan du godkänner.',
  'bank.toast.invoicePaymentDone': 'Fakturabetalningen är bokförd och bankraden är klar',
  'bank.toast.supplierPaymentDone': 'Leverantörsfakturan är betald och bankraden är klar',
  'bank.toast.enterSupplierName': 'Ange leverantörsnamn innan fakturan godkänns.',
  'bank.toast.enterInvoiceNumber': 'Ange fakturanummer innan fakturan godkänns.',
  'bank.toast.checkCostAccount': 'Kontrollera kostnadskontot innan fakturan godkänns.',
  'bank.toast.supplierInvoiceDone': 'Leverantörsfakturan är bokförd och bankraden är klar',
  'bank.toast.suggestionDone': 'Förslaget är bokfört och bankraden är klar',
  'bank.toast.alreadyDone': 'Bankraden är redan bokförd och klar',
  'bank.toast.suggestionNotApproved': 'Förslaget kunde inte godkännas.',
  'bank.toast.suggestionNeedsReview': 'Förslaget måste kontrolleras före godkännande.',
  'bank.approve': 'Godkänn',
  'bank.toast.pickUnprocessed': 'Välj minst en ohanterad bankrad.',
  'bank.toast.approveLineFailed': 'Kunde inte godkänna bankraden.',
  'bank.toast.nLinesApproved': '{{count}} rader godkända',
  'bank.toast.lineAdded': 'Bankrad tillagd',
  'bank.toast.lineLinkUnavailable': 'Koppling av bankrad är inte tillgänglig ännu.',
  'bank.toast.linkedToExistingPosted': 'Bankraden är kopplad mot befintlig bokförd post',
  'bank.controlPosting.title': 'Bokförd bankpost',
  'bank.controlPosting.sub': 'Möjlig avvikelse: bokförd på bankkontot, men hittades inte i kontoutdraget.',
  'bank.toast.openedAsDeviation': 'Bankraden har öppnats som avvikelse',
  'bank.toast.investmentMatchReopened': 'Bankkopplingen till investeringen har frigjorts',
  'bank.toast.balanceCorrectionUnavailable': 'Saldokorrigering är inte tillgänglig ännu.',
  'bank.toast.openingMustBeNumber': 'Ingående saldo måste vara ett tal.',
  'bank.toast.openingUpdated': 'Ingående saldo uppdaterat',
  'bank.toast.openingFromImport': 'Ingående saldo satt från importövergången',
  'bank.toast.closingMustBeNumber': 'Utgående saldo måste vara ett tal.',
  'bank.toast.closingUpdated': 'Utgående saldo uppdaterat',
  'bank.toast.roundingMustBeNumber': 'Öresdifferens måste vara ett tal.',
  'bank.toast.roundingCorrected': 'Öresdifferens korrigerad',
  'bank.mark.posted': 'Bokförd',
  'bank.mark.alreadyPosted': 'Redan bokförd',
  'bank.mark.approved': 'Godkänd',
  'bank.mark.needsReview': 'Behöver kontrolleras',
  'bank.mark.deviation': 'Möjlig avvikelse',
  'bank.mark.suggestion': 'Förslag klart',
  'bank.mark.private': 'Privat',
  'bank.mark.removed': 'Borttagen',
  'bank.mark.new': 'Inte hanterad',
  'bank.toast.analysisUnavailable': 'SuperPlumma-analys är inte tillgänglig ännu.',
  'bank.toast.foundSuggestions': 'SuperPlumma hittade {{count}} förslag att kontrollera',
  'bank.toast.noSafeSuggestions': 'SuperPlumma hittade inga säkra förslag',
  'bank.toast.analysisFailed': 'SuperPlumma kunde inte analysera bankraderna.',
  'bank.toast.alreadyArchived': 'Kontoutdraget är redan avstämt och arkiverat.',
  'bank.toast.reconciledArchived': 'Kontoutdraget är avstämt och arkiverat.',
  'bank.toast.reopenFailed': 'Kunde inte öppna avstämningen igen.',
  'bank.matchMultiple': 'Matcha flera',
  'bank.transition.title': 'Kontrollera övergången från importerad bokföring',
  'bank.transition.changeAnchor': 'Ändra ”Avstämd till och med” och startsaldo i Inställningar om importankaret sattes fel.',
  'bank.previousNotReconciled': 'Tidigare period är inte avstämd',
  'bank.correctViaPencil': 'Korrigera via pennikonen',
  'bank.correctReadBalance': 'Korrigera avläst saldo',
  'bank.analysis.alreadyDone': 'Kontoutdraget är redan analyserat. Ny analys är spärrad för att undvika onödig tokenanvändning.',
  'bank.analysis.autoRunning': 'SuperPlumma analyserar kontoutdraget automatiskt.',
  'bank.analysis.analyzedShort': 'Analyserat av SuperPlumma',
  'bank.analysis.analyzingShort': 'SuperPlumma analyserar',
  'bank.archiveBlocked.chronological': 'Stäm av {{name}} först. Avstämning måste göras i kronologisk ordning, eftersom ingående saldo hämtas från föregående kontoutdrag.',
  'bank.archiveBlocked.deviation': 'Saldoavvikelsen måste vara 0,00 kr innan kontoutdraget kan arkiveras.',
  'bank.archiveBlocked.lines': 'Alla bankrader måste hanteras innan kontoutdraget kan arkiveras.',
  'bank.reviewAndApprove': 'Kontrollera och godkänn',
  'bank.voucherN': 'Verifikation {{n}}',
  'bank.voucherLinked': 'Verifikation kopplad',
  'bank.showVoucher': 'Visa verifikation',
  'bank.voucherSuggested': 'Verifikation föreslagen',
  'bank.voucherMissingBadge': 'Verifikation saknas',
  'bank.toast.linkRemoved': 'Kopplingen har tagits bort. Verifikationen ligger i inkorgen.',
  'bank.sendVouchersBack': 'Skicka tillbaka verifikationerna till inkorgen',
  'bank.toast.vouchersSentBack': 'Verifikationerna har skickats tillbaka till inkorgen',
  'bank.analysisHint.tap': 'Låt SuperPlumma analysera raderna och föreslå bokföring, eller tryck på en verifikation och sedan på bankraden för att koppla.',
  'bank.analysisHint.drag': 'Låt SuperPlumma analysera raderna och föreslå bokföring, eller dra en verifikation direkt till bankraden för att koppla.',
  'bank.showInbox': 'Visa inkorg',
  'bank.toast.lineDone': 'Bankraden är bokförd och klar',
  'bank.toast.noInboxVouchers': 'Inga verifikationer i inkorgen att koppla.',
  'bank.toast.balanceCorrected': 'Saldot har korrigerats',
  'bank.toast.misreadRemoved': 'Den felavlästa raden har tagits bort från avstämningen',
  'bank.toast.readingCorrected': 'Avläsningen har korrigerats',
  'bank.toast.postedFixed': 'Den bokförda posten har rättats',
  'bank.toast.lineRemoved': 'Bankraden har tagits bort från avstämningen',
  'bank.vatTerm.jun': 'Moms {{year}} - 10 juni',
  'bank.vatTerm.apr': 'Moms {{year}} - 10 april',
  'bank.vatTerm.feb': 'Moms {{year}} - 10 februari',
  'bank.vatTerm.aug': 'Moms {{year}} - 31 augusti',
  'bank.vatTerm.oct': 'Moms {{year}} - 10 oktober',
  'bank.vatTerm.dec': 'Moms {{year}} - 10 december',
  'bank.agaTerm': 'Löneskatt/AGA termin {{n}} {{year}}',
  'bank.ownerAccountFallback': 'Privat-/ägarkonto',
  'bank.periodHint': 'Bankutdraget gäller {{from}} - {{to}}.',
  'bank.voucher': 'Verifikation',
  'bank.ownerType.withdrawal': 'Privat uttag',
  'bank.ownerType.deposit': 'Privat insättning',
  'bank.ownerType.both': 'Privat uttag / insättning',
  'bank.ownerType.owner': 'Ägare / avräkning',
  'bank.vat86.prefix': 'Leverantörsbeloppet',
  'bank.vat86.suffix': 'är underlaget. Kod 86 beräknar både utgående och ingående moms med 25 % utan att minska bankbeloppet.',
  'bank.postedWithoutVat': 'bokförs utan moms.',
  'bank.withVatRate': 'med {{rate}} % moms.',
  'bank.amountHelp.locked': 'Beloppet är hämtat från bankutdraget och kan inte ändras.',
  'bank.amountHelp.unlocked': 'Konteringen är inte kopplad till en bankrad, så beloppet kan rättas här. Ändringen sparas i verifieringskedjan.',
  'bank.amountHelp.mustMatch': 'Beloppet måste stämma med den faktiska banktransaktionen.',
  'bank.err.enterAmount': 'Ange bankbelopp innan du sparar raden.',
  'bank.err.dateWithinStatement': 'Datumet måste ligga inom bankutdraget: {{from}} - {{to}}.',
  'bank.err.pickTwoAccountsFree': 'Välj två olika konton innan du sparar fri kontering.',
  'bank.err.enterSupplierName': 'Ange leverantörsnamn innan du sparar leverantörsfakturan.',
  'bank.err.enterInvoiceNumber': 'Ange fakturanummer innan du bokför leverantörsfakturan.',
  'bank.err.invoicePaymentIncoming': 'En fakturabetalning måste vara en inbetalning till banken.',
  'bank.err.pickInvoice': 'Välj faktura innan du sparar fakturabetalningen.',
  'bank.err.pickOwnerAccount': 'Välj privat-/ägarkonto innan du godkänner bokföringen.',
  'bank.err.pickLoanAccount': 'Välj låne-/skuldkonto eller använd fri kontering.',
  'bank.err.loanSplitSum': 'Amortering, ränta och avgift måste summera till bankbeloppet.',
  'bank.err.supplierPaymentOutgoing': 'Betalning av leverantörsfaktura måste vara en utbetalning från banken.',
  'bank.err.pickSupplierInvoiceBeforeSave': 'Välj leverantörsfaktura innan du sparar betalningen.',
  'bank.err.correctionReason': 'Skriv kort varför konteringen korrigeras.',
  'bank.err.noReceiptReason': 'Ange en kort motivering till varför en egen verifikation inte behövs.',
  'bank.err.linkVoucherOrWaive': 'Koppla en verifikation eller markera att separat dokumentation inte finns eller inte behövs.',
  'bank.err.uploadUnavailable': 'Uppladdning av verifikationer är inte tillgänglig ännu.',
  'bank.err.analysisFailedAfterUpload': 'Verifikationen laddades upp, men analysen misslyckades.',
  'bank.toast.uploadedAndLinked': 'Verifikationen har laddats upp och kopplats till bankraden.',
  'bank.toast.linkOnSaveCorrection': 'Verifikationen kopplas när du sparar korrigeringen.',
  'bank.toast.linkOnSaveLine': 'Verifikationen kopplas när du sparar bankraden.',
  'bank.err.uploadFailed': 'Det gick inte att ladda upp verifikationen.',
  'bank.modal.correctPosting': 'Korrigera kontering',
  'bank.modal.editLine': 'Redigera bankrad',
  'bank.modal.saveCorrection': 'Spara korrigering',
  'bank.modal.approveAndClose': 'Godkänn och stäng',
  'bank.modal.fieldsLocked': 'Bankbelopp, datum, typ och bankkoppling är låsta. Konto, moms och intern beskrivning kan korrigeras med verifieringskedja.',
  'bank.modal.correctionUnlocked': 'Konteringen är inte kopplad till en bankrad i bankutdraget. Datum, belopp, konto, moms, verifikation och intern beskrivning kan korrigeras med verifieringskedja. Om själva konteringstypen är fel måste konteringen makuleras och bokföras på nytt.',
  'bank.modal.manualLineHelp': 'Använd detta bara när en faktisk banktransaktion saknas i utdraget, till exempel vid importfel eller en bankrad som måste bokföras manuellt före avstämning.',
  'bank.help.sales': 'Försäljning använder standardförsäljningskonto och momsinställningar. Senare kopplas detta mot faktura/KID när det finns.',
  'bank.help.ownerSole': '{{label}} bokförs mellan bank och valt privatkonto utan intäkt, kostnad eller moms.',
  'bank.help.ownerUnknownEntity': 'Företagsform är inte angiven i inställningarna, så Plumme föreslår inget konto här. Välj motkonto själv eller ange företagsform för att få förslag.',
  'bank.help.ownerIntercompany': 'Detta är en ägar-/avräkningspost, inte en privat ENK-post. Välj dokumenterat motkonto; lån, utdelning och kapitaltillskott måste hanteras i rätt flöde.',
  'bank.label.privateAccount': 'Privatkonto',
  'bank.label.ownerAccount': 'Ägar-/avräkningskonto',
  'bank.help.shareholderTitle': 'Uttag från bolaget.',
  'bank.help.shareholderBody': 'Avräkningen föreslås eftersom den samlar ägarförhållandet på ett saldo. Om detta inte är återbetalning av det bolaget är skyldigt dig blir det ett lån till aktieägare: asl. §8-7 ställer krav på täckning och säkerhet, och sktl. §10-11 fjärde stycket beskattar det som utdelning hos dig. Utdelning och lön ska bokföras i sina egna flöden.',
  'bank.help.invoicePayment': 'Använd detta när bankinbetalningen gäller en befintlig kundfaktura. Bokföringen går mot kundfordran och valt bankkonto.',
  'bank.settlement.linked': 'Avräkningsrapport kopplad:',
  'bank.settlement.detail': 'fakturan betalas med {{gross}}, avgift {{fee}} och netto bankinbetalning {{payout}}.',
  'bank.help.noInvoiceMatch': 'Ändra beloppet eller använd Annan försäljning om inbetalningen inte gäller en faktura.',
  'bank.help.supplierPayment': 'Använd detta när bankutbetalningen gäller en leverantörsfaktura som redan är registrerad. Betalningen bokförs mot leverantörsskulden och valt bankkonto.',
  'bank.pickOpenSupplierInvoice': 'Välj öppen leverantörsfaktura',
  'bank.supplierInvoiceRemaining': '{{number}} · {{supplier}} · återstår {{amount}}',
  'bank.overpayment': 'Överbetalning {{amount}}.',
  'bank.overpaymentHelp': 'Hela bankbeloppet registreras på leverantörsfakturan, och det överskjutande står kvar som tillgodohavande hos leverantören.',
  'bank.noSupplierInvoiceFits': 'Inga öppna leverantörsfakturor passar beloppet.',
  'bank.noSupplierInvoiceFitsHelp': 'Vid överbetalning måste restbeloppet matchas mot fakturan och överskottet bokföras separat.',
  'bank.help.taxPayment': 'Använd detta bara för betalningar till Skatteetaten som inte avser en konkret momsperiod eller skatteavdrag/AGA.',
  'bank.selectedFeeAccount': 'valt avgiftskonto',
  'bank.selectedRoundingAccount': 'valt avrundningskonto',
  'bank.help.roundingWarning': 'Öresdifferenser ska normalt vara mindre än 1 kr. Större avvikelser måste förklaras genom att kontrollera saldo och bankrader.',
  'bank.help.free': 'Fri kontering används för överföringar, skulder, avräkning, korrigeringar eller andra bankhändelser som inte är vanliga inköp, försäljningar eller fakturabetalningar.',
  'bank.help.newSupplierInvoice': 'Använd detta när leverantörsfakturan inte är registrerad ännu. Bankraden sparas med leverantörsfakturadetaljer så att den kan kopplas vidare.',
  'bank.correction.requiredHint': 'Obligatoriskt. Sparas i verifikationskedjan.',
  'bank.correction.reasonPh': 'Beskriv kort varför konteringen korrigeras',
  'bank.noSeparateDoc.bank': 'Kontoutdraget är dokumentation – egen verifikation behövs inte',
  'bank.noSeparateDoc.other': 'Ingen separat dokumentation finns eller behövs',
  'bank.shortReasonPh': 'Kort motivering',
  'bank.toast.pickFromInbox': 'Välj en verifikation från Inkorg, inte Dokumentation.',
  'bank.toast.linkedOnCorrection': 'Verifikationen kopplas när du sparar korrigeringen.',
  'bank.toast.linkedToLine': 'Verifikationen är kopplad till bankraden.',
  'bank.priv.filterAll': 'Alla',
  'bank.priv.filterOperating': 'Drift',
  'bank.priv.filterNew': 'Ej hanterade',
  'bank.priv.filterIgnore': 'Ignorera',
  'bank.priv.statusIgnored': 'Ignorerad',
  'bank.priv.noSafeMatches': 'Inga säkra verifikationsmatchningar att koppla ännu',
  'bank.priv.linkedN': 'Kopplade {{count}} verifikationer mot privata bankrader',
  'bank.priv.pickOneLine': 'Välj minst en bankrad.',
  'bank.priv.ignoredN': '{{count}} rader ignorerade',
  'bank.priv.movedN': '{{count}} rader flyttade till driften',
  'bank.priv.intro': 'Privat bank används som ett städverktyg: markera företagsrelaterade rader som Drift och ignorera privata eller irrelevanta rader. Det som markeras för driften bokförs på företagskontot.',
  'bank.priv.movedToOperating': 'Flyttad till driften',
  'bank.priv.noteTap': 'Låt SuperPlumma koppla dem automatiskt, eller tryck på en verifikation och sedan på bankraden.',
  'bank.priv.noteDrag': 'Låt SuperPlumma koppla dem automatiskt, eller dra en verifikation direkt till bankraden.',
  'bank.toast.lineUpdated': 'Bankraden uppdaterad',
  'bank.err.excelParserMissing': 'Excel-parsern är inte inläst.',
  'bank.err.pdfParserMissing': 'PDF-parsern är inte inläst.',
  'bank.toast.addBankAccountFirst': 'Lägg först till ett bankkonto i inställningarna',
  'bank.err.archiveUnavailable': 'Arkivering av kontoutdrag är inte tillgänglig ännu.',
  'bank.toast.privateReviewArchived': 'Privatgenomgången är slutförd och arkiverad',
  'bank.err.archiveFailed': 'Det gick inte att arkivera kontoutdraget',
  'bank.err.reopenUnavailable': 'Återöppning av kontoutdrag är inte tillgänglig ännu.',
  'bank.toast.statementReopened': 'Kontoutdraget har öppnats igen',
  'bank.err.reopenStatementFailed': 'Det gick inte att öppna kontoutdraget igen',
  'bank.account.private': 'Privatkonto',
  'bank.account.operating': 'Företagskonto',
  'bank.group.operating': 'Företagskonton',
  'bank.group.private': 'Privatkonton',
  'bank.group.doneReviews': 'Färdiggranskade privata kontoutdrag',
  'bank.group.doneReconciled': 'Färdigavstämda kontoutdrag',
  'bank.unknownPeriod': 'Okänd period',
  'bank.handledOf': '{{handled}} av {{lines}} hanterade',
  'bank.page.privateTitle': 'Privat bank',
  'bank.page.title': 'Bankavstämning',
  'bank.page.privateSubtitle': 'Städa i privatkontot - markera företagsrelaterade rader som drift och ignorera resten.',
  'bank.page.subtitle': 'Läs in XLSX, CSV, PDF eller en skärmbild från banken, markera företagsrader som drift och arkivera färdiga kontoutdrag.',
  'bank.tab.operating': 'Drift',
  'bank.tab.private': 'Privat',
  'bank.tab.archive': 'Arkiv',
  'bank.page.privateUploadHelp': 'Ladda upp det privata kontoutdraget här bara när du vill hitta företagsrelaterade utlägg. Det sparas på valt företag, men utan bankkonto från Inställningar.',
  'bank.noAccountRegistered': 'Inget bankkonto registrerat',
  'bank.stmt.reviewed': 'Granskad',
  'bank.stmt.toReview': 'Att granska',
  'bank.stmt.toReconcile': 'Att stämma av',
  'bank.dropzone.uploadMore': 'Ladda upp fler kontoutdrag',
  'bank.dropzone.none': 'Inga kontoutdrag ännu',
  'bank.dropzone.help': 'Dra in en CSV-, PDF-, XLSX- eller bildfil från banken, klicka för att välja eller klistra in en skärmbild med Ctrl+V. Vi matchar raderna mot dina verifikationer automatiskt.',
  'bank.connectHelp2': 'Hämta transaktioner automatiskt och låt SuperPlumma bokföra och stämma av bokföringen löpande - slipp manuell uppladdning och bokföring.',
  'bank.toast.openBankingInfo': 'Säker anslutning till banken via Open Banking',
  'bank.guided.step1.title': 'Kontrollera kontoutdraget',
  'bank.guided.step1.sub': 'Kontrollera period och saldo',
  'bank.guided.step2.title': 'Godkänn förslag',
  'bank.guided.step2.sub': 'Kontrollera det Plumme har hittat',
  'bank.guided.step3.title': 'Hantera resten',
  'bank.guided.step3.sub': 'Välj vad betalningarna gäller',
  'bank.guided.step4.title': 'Koppla verifikationer',
  'bank.guided.step4.sub': 'Dokumentera inköpen',
  'bank.guided.step5.title': 'Slutför',
  'bank.guided.step5.sub': 'Kontrollera och arkivera',
  'bank.guided.stepOf': 'Steg {{step}} av {{total}}',
  'bank.guided.action.matched': 'Matchad mot redan bokförd',
  'bank.guided.action.fee': 'Bankavgift',
  'bank.guided.action.invoice': 'Fakturabetalning',
  'bank.guided.action.purchase': 'Känt inköp',
  'bank.guided.action.sale': 'Registrera försäljning',
  'bank.guided.suggestionFromSuper': 'Förslag från SuperPlumma',
  'bank.guided.receivables': 'Kundfordringar',
  'bank.guided.suggestedCostAccount': 'Föreslaget kostnadskonto',
  'bank.guided.reason.sameAmount': 'Samma belopp och betalningsreferens',
  'bank.guided.reason.textBased': 'Baserat på text, belopp och tidigare bokföring',
  'bank.guided.suggestsAction': 'Plumme föreslår: {{action}}',
  'bank.guided.vatLine': '{{account}} · {{vat}} moms · Belopp {{amount}}',
  'bank.guided.voucherSuffix': ' · verifikation: {{name}}',
  'bank.guided.out': 'UT',
  'bank.guided.in': 'IN',
  'bank.guided.moneyOut': 'PENGAR UT',
  'bank.guided.moneyIn': 'PENGAR IN',
  'bank.guided.unprocessedLine': '{{direction}} · Ej hanterad',
  'bank.guided.bankPeriod': 'Bankperiod',
  'bank.guided.handledLeft': '{{handled}}/{{total}} hanterade · {{left}} kvar',
  'bank.guided.reopenNote': 'Om du öppnar avstämningen igen låses perioden upp för kontroll. Bokförda rader måste korrigeras eller annulleras med verifikationskedja innan de kan hanteras på nytt.',
  'bank.guided.toast.enterClosing': 'Ange slutsaldot från kontoutdraget.',
  'bank.guided.err.checkIndividually': 'Ett eller flera förslag måste kontrolleras ett i taget.',
  'bank.guided.toast.suggestionsDone': '{{count}} förslag är bokförda och klara',
  'bank.guided.err.approveSuggestions': 'Det gick inte att godkänna förslagen.',
  'bank.guided.toast.roundingPosted': 'Avrundningsdifferensen på {{amount}} är bokförd',
  'bank.guided.err.roundingFailed': 'Det gick inte att bokföra avrundningsdifferensen.',
  'bank.guided.toast.markedNoVoucher': 'Inköpet är markerat utan verifikation',
  'bank.guided.err.saveChoice': 'Det gick inte att spara valet.',
  'bank.guided.err.voucherNotFound': 'Hittade inte verifikationen i inkorgen.',
  'bank.guided.err.linkFailed': 'Det gick inte att koppla verifikationen.',
  'bank.guided.toast.noSafeHits': 'Hittade inga säkra verifikationsträffar att koppla.',
  'bank.guided.h.check': 'Stämmer perioden och saldot?',
  'bank.guided.h.rest': 'Vad gäller de återstående betalningarna?',
  'bank.guided.p.check': 'Kontrollera att detta är rätt kontoutdrag och ange saldot som står i slutet av perioden.',
  'bank.guided.p.rest': 'Välj vad varje betalning gäller. Du behöver inte kunna kontonummer — Plumme hjälper dig med bokföringen.',
  'bank.guided.openingHint': 'Hämtas normalt från föregående färdiga avstämning.',
  'bank.guided.closingHint': 'Hitta beloppet på kontoutdraget från banken.',
  'bank.guided.closingMatches': 'Bankens slutsaldo är lika med det Plumme har beräknat.',
  'bank.guided.posting': 'Bokför…',
  'bank.guided.postRounding': 'Bokför avrundningsdifferensen',
  'bank.guided.smallRounding': 'Liten avrundningsavvikelse på {{amount}}',
  'bank.guided.balanceDeviates': 'Saldot avviker med {{amount}}.',
  'bank.guided.balanceDeviatesHelp': 'Hantera betalningarna i nästa steg och kom tillbaka om avvikelsen kvarstår.',
  'bank.guided.canReturn': 'Du kan alltid komma tillbaka till det här steget senare.',
  'bank.guided.correctToContinue': 'Korrigera saldona med pennikonen för att gå vidare.',
  'bank.guided.checkedContinue': 'Kontoutdraget är kontrollerat – fortsätt',
  'bank.guided.superIntro': 'Vissa rader är matchade mot poster som redan är bokförda, för andra har SuperPlumma föreslagit bokföring. Kontrollera dem och tryck på godkänn — ingenting bokförs förrän du godkänner.',
  'bank.guided.count.matched': 'matchade mot redan bokförda',
  'bank.guided.count.invoice': 'fakturabetalningar',
  'bank.guided.count.purchase': 'kända inköp',
  'bank.guided.count.fee': 'bankavgifter',
  'bank.guided.count.receipt': 'verifikationer hittade automatiskt',
  'bank.guided.fixReading': 'Korrigera inläsning från PDF/CSV',
  'bank.guided.suggestionsPending': '{{count}} förslag är inte godkända ännu. Du kan godkänna dem nu eller komma tillbaka.',
  'bank.guided.allSuggestionsDone': 'Alla förslag är hanterade.',
});
